import React, { PureComponent } from 'react'
import {
  func, shape, bool, string,
} from 'prop-types'
import Button from '@active/react-ui/Button'
import Form, { FormConsumer } from '@active/react-ui/Form'
import Identity from '@active/react-utils/components/Identity'
import { noop } from '../../../shared/utils/commonUtils'
import CommonError from '../CommonError'
import ConfirmedPassword from '../ConfirmedPassword'
import I18nMessage from '../I18nMessage'

class PasswordContent extends PureComponent {
  static propTypes = {
    handlePasswordContentSubmit: func.isRequired,
    showError: bool,
    messageType: string,
    message: string,
    username: string,
    initCleanPswd: func,
    fields: shape({}),
    Body: func,
    Footer: func,
  }

  static defaultProps = {
    showError: false,
    messageType: null,
    message: null,
    username: '',
    initCleanPswd: noop,
    fields: {},
    Body: Identity,
    Footer: Identity,
  }

  formRef

  constructor(props) {
    super(props)

    this.state = {
      fields: { ...props.fields },
    }
  }

  componentDidMount() {
    const { initCleanPswd } = this.props
    initCleanPswd(this.resetPswd)
  }

  resetPswd = () => {
    this.formRef.handleReset()
  }

  triggerSubmit = () => {
    this.formRef.submitForm()
  }

  render() {
    const {
      showError, messageType, message, handlePasswordContentSubmit, username, Body, Footer,
    } = this.props

    const { fields } = this.state
    return (
      <Identity>
        <Body>
          <div className="passport-content password-content">
            <Form initialValues={fields} onSubmit={handlePasswordContentSubmit}>
              <div className="passport__password-updater__message-box">
                {showError && <CommonError showError={showError} msgType={messageType} errMsg={message} />}
                <div className="passport-ui-app__subTitle passport__pb5">
                  <I18nMessage id="passport.signin.password.updater.notice" />
                </div>
              </div>
              <ConfirmedPassword
                passwordLabel="passport.resetPassword.label.password"
                name="newPswd"
                required
                username={username}
              />
              <FormConsumer>
                {({ form }) => {
                  this.formRef = form
                  return null
                }}
              </FormConsumer>
            </Form>
          </div>
        </Body>
        <Footer>
          <div className="passport-content-footer">
            <Button type="super" onClick={this.triggerSubmit}>
              <I18nMessage id="passport.resetPassword.btn.resetPwdBtn" />
            </Button>
          </div>
        </Footer>
      </Identity>
    )
  }
}

export default PasswordContent
